import React, { FC, useState, useEffect } from "react";
import {
  GoogleMap,
  useJsApiLoader,
  MarkerF,
} from "@react-google-maps/api";

type Location = {
  lat: number;
  lng: number;
}

interface MapGoogleProps {
  location: Location;
  setLocation: (location: Location) => void;
  onChange?: (value?: any) => void

  /** ความสูงของกล่องแผนที่ — ค่าเริ่มต้น 50vh สูงเกินไปเมื่ออยู่ใน dialog */
  height?: string;
}


const MapGoogle: FC<MapGoogleProps> = ({ onChange, location, setLocation, height }) => {


  const center = { lat: location.lat, lng: location.lng };

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyDY9xrY9bAqJ9h94u3xrJx-QxVbwu9nSTE"
  });

  const [markers, setMarkers] = useState<Location | null>()
  const [zoom, setZoom] = useState<number>(10)

  const containerStyle = {
    width: "100%",
    height: height ?? "50vh"
  };


  useEffect(() => {
    setMarkers(location)
    if(location.lat !== 13.736717){
      setZoom(18)
    }
  }, [location])

  const onClick = (...args: any[]) => {
    // console.log(
    //   'onClick args: ',
    //   args[0].latLng.lat(),
    //   ' : ',
    //   args[0].latLng.lng()
    // )

    setMarkers({ lat: args[0].latLng.lat(), lng: args[0].latLng.lng() })

    onChange && onChange({ lat: args[0].latLng.lat(), lng: args[0].latLng.lng() })

    setLocation({ lat: args[0].latLng.lat(), lng: args[0].latLng.lng() })
  }

  return isLoaded ? (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={center}
      zoom={zoom}
      onClick={onClick}
    >
      {markers && <MarkerF position={markers} />}
    </GoogleMap>
  ) : null;
}

export default MapGoogle;
